/*
*
* File JS per la Basic Page
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import stepBlock from 'components/step-block/step-block';

import timelineCarousel from 'components/timeline-carousel/timeline-carousel';

import galleryCarousel from 'components/gallery-carousel/gallery-carousel';

import sustainability from 'components/sustainability/sustainability';

import download from 'components/download/download';

import galleryVideoCarousel from 'components/gallery-video/gallery-video';

import certification from 'components/certification/certification';

import number from 'components/number/number';

import fullBg from 'components/full-bg/full-bg';

import textImg from 'components/text-img/text-img';

import missionTabs from 'components/mission-tabs/mission-tabs';

import modal from 'components/modal/modal';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './basic-page.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

stepBlock();

timelineCarousel();

galleryCarousel();

sustainability();

download();

galleryVideoCarousel();

certification();

number();

fullBg();

textImg();

missionTabs();

modal();

//--------------------------------------------------------------------//